<template>
  <v-dialog v-model="clickDialog" persistent max-width="70%">
    <v-card>
      <v-card-title class="primary">
        <span class="white--text" style="width: 100%">
          Details
          <v-btn
            data-cy="close"
            class="primary lighten-1 float-right"
            dark
            icon
            @click="closeDetailDialog"
          >
            <v-icon color="white--text">mdi-close</v-icon>
          </v-btn>
        </span>
      </v-card-title>
      <v-card-text>
        <v-container class="black--text pt-5">
          <div class="d-flex title font-weight-bold">
            <p data-cy="custNo" class="text-right ml-10">{{ custNo }}</p>
            <p data-cy="compName" class="text-left ml-10">{{ compName }}</p>
          </div>

          <div class="d-flex body-1 mt-2">
            <p class="rowStyle pr-10 pl-2 font-weight-bold py-1">Balance:</p>
            <span data-cy="custBal" class="ml-10">{{
              custBal | currency
            }}</span>
            <div class="flex-grow-1"></div>
            <v-btn
              data-cy="refresh"
              class="primary"
              :disabled="dialog"
              :loading="dialog"
              @click="
                dialog = true;
                initialize(loadData);
              "
              >Refresh Table</v-btn
            >
            <v-dialog v-model="dialog" persistent width="300">
              <v-card color="primary" dark>
                <v-card-text class="pt-3 white--text">
                  Please stand by
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>

          <div class="body-1 mt-8">
            <p class="rowStyle pl-2 d-block font-weight-bold py-1">
              Contact Log:
            </p>
            <v-data-table
              data-cy="logs"
              :headers="logHeader"
              :items="contactLogs"
              :items-per-page="fullContactLogCtr"
              :loading="loading"
              no-data-text="No data to display"
            >
              <template v-slot:item.dateAdded="{ value, item }">{{
                value | formatDate
              }}</template>
            </v-data-table>
            <div class="d-flex">
              <v-btn
                data-cy="addNote"
                class="primary pa-2 mt-3 d-inline"
                @click="addItem()"
                >{{ button.log }}</v-btn
              >
              <v-btn
                class="primary pa-2 mt-3 ml-3 d-inline full-contact-log"
                @click="displayFullContactLog"
                >Full Contact Log</v-btn
              >
            </div>
          </div>

          <div class="body-1 mt-3">
            <p class="rowStyle pl-2 d-block font-weight-bold py-1">Payments:</p>
            <v-data-table
              data-cy="payment"
              :headers="paymentHeader"
              :items="payments"
              :items-per-page="fullPaymentLogCtr"
              :loading="loading"
              no-data-text="No data to display"
            >
              <template v-slot:item.dateAdded="{ value, item }">{{
                value | formatDate
              }}</template>
              <template v-slot:item.amount="{ value, item }">{{
                value | currency
              }}</template>
            </v-data-table>
            <v-btn
              data-cy="full-payment-log"
              class="primary pa-2 mt-3"
              @click="displayFullPayment()"
              >Full Payment Log</v-btn
            >
          </div>

          <div class="body-1 mt-8">
            <p class="rowStyle pl-2 d-block font-weight-bold py-1">Credits:</p>
            <v-data-table
              :headers="creditHeader"
              :items="credits"
              :items-per-page="5"
              :loading="loading"
              no-data-text="No data to display"
            >
              <template v-slot:item.dateAdded="{ value, item }">{{
                value | formatDate
              }}</template>
              <template v-slot:item.amount="{ value, item }">{{
                value | currency
              }}</template>
            </v-data-table>
          </div>

          <NoteDialog
            :customer="clickData"
            :customerNumber="clickData.customerNo"
          ></NoteDialog>

          <v-snackbar color="red" v-model="snackbar" :timeout="timeout">{{
            text
          }}</v-snackbar>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import NoteDialog from "@/components/dialogs/NoteDialog";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DetailsDialog",
  data: () => ({
    paymentBtn: "Full Payment Log",
    creditBtn: "Add Credit",
    logBtn: "Add Note",
    seen: true,
    button: {
      credit: "Add Credit",
      log: "Add Note"
    },
    item: [],
    dialog: false,
    name: "",
    date: "",
    credit: 0,
    comment: "",
    user: "",
    notes: "",
    paymentHeader: [
      { text: "Date", value: "dateAdded", sortable: false },
      { text: "Credit", value: "amount", sortable: false },
      { text: "Comment", value: "comments", sortable: false }
    ],
    creditHeader: [
      { text: "Date", value: "dateAdded", sortable: false },
      { text: "Credit", value: "amount", sortable: false },
      { text: "Comment", value: "comments", sortable: false }
    ],
    logHeader: [
      { text: "Date", value: "dateAdded", sortable: false },
      { text: "User", value: "userAction", sortable: false },
      { text: "Notes", value: "notes", sortable: false }
    ],
    rowData: [],
    noDataLoading: "No Data Found",
    loading: true,
    snackbar: false,
    text: "No data to display.",
    timeout: 5000,
    fullPaymentLogCtr: 5,
    fullContactLogCtr: 5,
    loadData: []
  }),
  props: {
    clickData: { type: Object },
    clickDialog: { type: Boolean, required: true }
  },
  components: {
    NoteDialog
  },
  methods: {
    ...mapActions("reminders", ["getFinancials"]),
    ...mapActions("financials", ["fetchFinancials"]),
    ...mapActions("logs", ["updateNoteDialogStatus"]),
    closeDetailDialog() {
      this.fullPaymentLogCtr = 5;
      this.fullContactLogCtr = 5;
      this.loading = true;
      this.$emit("close");
    },
    refreshData(item) {
      let vm = this;
      this.loading = true;
      vm.getFinancials(item)
        .then(data => {
          vm.financials = data;
        })
        .catch(() => {
          this.dialog = false;
          this.loading = false;
        });
    },
    addItem() {
      this.updateNoteDialogStatus();
      this.fullPaymentLogCtr = this.logs.filter(
        x => x.name === "paymentLog"
      ).length;
    },
    displayFullPayment() {
      this.fullPaymentLogCtr = this.logs.filter(
        x => x.name === "paymentLog"
      ).length;
    },
    displayFullContactLog() {
      this.fullContactLogCtr = this.contactLogs.length;
    },
    initialize(item) {
      this.$set(this, "noDataLoading", "Loading Data");
      this.financials = {};
      this.fetchFinancials(item).then(data => {
        this.loadData = data;
        this.dialog = false;
        this.loading = false;
      });
    }
  },
  computed: {
    ...mapGetters("logs", ["logs"]),
    ...mapGetters("financials", ["payments", "credits", "contactLogs"]),
    compName() {
      return this.clickData.company;
    },
    custNo() {
      return this.clickData.customerNo;
    },
    custBal() {
      return this.clickData.balance;
    }
  },
  filters: {
    currency: function(value) {
      let credit;

      if (!value) return "";

      if (parseFloat(value) < 0) {
        value *= -1;
        credit = `-$${parseFloat(value).toFixed(2)}`;
      } else {
        credit = `$${parseFloat(value).toFixed(2)}`;
      }

      return credit;
    },
    formatDate: function(date) {
      if (!date) return null;

      const [year, month, day] = date.substring(0, 10).split("-");
      return `${day}/${month}/${year}`;
    }
  },
  mounted() {
    this.initialize(this.clickData)
  }
};
</script>

<style lang="scss">
.rowStyle {
  background-color: #5e85a9;
  color: #fff;
}
</style>
